<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6igu8k/tc-custom/9780062101440.jpg?1733089701240" alt="This image is the cover for the book Jane Austen"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Jane Austen
      </h1>
      <p class="bookDescription body article font2">
        <p>It is 1810, and the Damned are out of favor—banished from polite society. Jane Austen’s old undead friends have become new neighbors, raising hell in her tranquil village just in time to interrupt Jane’s work on what will be her masterpiece. Suddenly Jane’s niece is flirting dangerously with vampires, and a formerly respectable spinster friend has discovered the forbidden joys of intimate congress with the Damned (and is borrowing Jane’s precious silk stockings for her assignations). Writing is simply impossible now, with murderous creatures prowling the village’s once-peaceful lanes. And with the return of her vampire characteristics, a civil war looming between factions of the Damned, and a former lover who intends to spend eternity blaming her for his broken heart, Jane is facing a very busy year indeed.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Janet Mullany
      </h2>
      
      <p class="authorDescription body article"><P>The author of <I>Jane and the Damned</I>, Janet Mullany was reared in England on a diet of Jane Austen and Georgette Heyer and now lives near Washington, D.C. She has worked as an archaeologist, waitress, draftsperson, radio announcer, performing arts administrator, proof-reader, and bookseller.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?716777ac